import { gsap, TweenLite, CSSPlugin } from "gsap/all"

gsap.registerPlugin(CSSPlugin)

export default class {
  constructor () {
    this.$readmores = document.querySelectorAll('.readmore')

    this.bindEvents()
  }

  bindEvents () {
    this.$readmores.forEach(element => {
      new Readmore(element)
    })
  }
}

class Readmore {
  constructor (item) {
    this.$readmore = item
    this.$readmoreContent = this.$readmore.querySelectorAll('.readmore__content')
    this.$readmoreLink = this.$readmore.querySelector('.readmore__link')

    this.$readmoreMaxHeight = this.$readmore.dataset.readmore

    this.textOpen = this.$readmore.dataset.readmoreTextOpen
    this.textClose = this.$readmore.dataset.readmoreTextClose

    this.isOpen = false

    this.bindEvents()
  }

  bindEvents () {
    this.currentTextIsToHigh()
    this.onClickReadmoreHandler()
    this.$readmoreLink.addEventListener('click', this.onClickReadmoreHandler.bind(this))
  }

  currentTextIsToHigh () {
    if (this.$readmoreContent[0].offsetHeight > this.$readmoreMaxHeight) {
      this.$readmoreContent.forEach(element => {
        TweenLite.to(element, 0.2, { maxHeight: this.$readmoreMaxHeight, overflow: 'hidden' })
      })
      console.log(this.$readmoreLink)
      TweenLite.set(this.$readmoreLink, { opacity: '1', pointerEvents: 'auto' })
    }
  }

  onClickReadmoreHandler () {
    !this.isOpen ? this.openReadmore() : this.closeReadmore()
    this.isOpen = !this.isOpen
  }

  openReadmore () {
    this.$readmoreContent.forEach(element => {
      TweenLite.to(element, 0.5, { height: this.$readmoreMaxHeight })
    })
    this.$readmoreLink.innerHTML = this.textOpen
  }

  closeReadmore () {
    this.$readmoreContent.forEach(element => {
      TweenLite.set(element, { height: 'auto' })
      TweenLite.from(element, 0.5, { height: this.$readmoreMaxHeight })
    })
    this.$readmoreLink.innerHTML = this.textClose
  }
}
